export const accessCardConstants = {
  // GET_ALL: 取得所有公告
  GET_ALL_REQUEST: "ACCESS_CARD_GET_ALL_REQUEST",
  GET_ALL_SUCCESS: "ACCESS_CARD_GET_ALL_SUCCESS",
  GET_ALL_FAILURE: "ACCESS_CARD_GET_ALL_FAILURE",
  RESET_ALL_SUCCESS: "ACCESS_CARD_RESET_ALL_SUCCESS",
  // EDIT: 編輯門禁卡
  EDIT_REQUEST: "ACCESS_CARD_EDIT_REQUEST",
  EDIT_SUCCESS: "ACCESS_CARD_EDIT_SUCCESS",
  EDIT_FAILURE: "ACCESS_CARD_EDIT_FAILURE",
  RESET_EDIT_SUCCESS: "ACCESS_CARD_RESET_EDIT_SUCCESS",
  // GET_EDIT: 取得編輯門禁卡
  GET_EDIT_REQUEST: "ACCESS_CARD_GET_EDIT_REQUEST",
  GET_EDIT_DONE: "ACCESS_CARD_GET_EDIT_DONE",
};
